import { faIcon } from "@utils/faIcon"

import { TabItem } from "@atoms"

import { Popover, TabStack } from "@molecules"
import ToggleListItem from "@molecules/ListItem/ToggleListItem/ToggleListItem"

import useJobTimelineViewEventHandlers from "@pages/Jobs/JobList/views/JobTimelineView/hooks/useJobTimelineViewEventHandlers"
import useTimelineViewStates from "@pages/Jobs/JobList/views/JobTimelineView/hooks/useJobTimelineViewStates"

import styles from "./TimelineViewMenu.module.scss"
import TimelineViewTimeFrameSelector from "./TimelineViewTimeFrameSelector/TimelineViewTimeFrameSelector"

export const TIMELINE_VIEW_MENU_COMPONENT_IDS = ["main"]

export default function TimelineViewMenu() {
    const {
        jobCardStyle,
        setJobCardStyleToCompact,
        setJobCardStyleToRegular,
        shouldShowCancelledJobs,
        shouldShowFinalizedJobs,
        timelineViewOrientation,
        shouldShowWeekends,
    } = useTimelineViewStates()

    const {
        onCancelledJobsToggle,
        onFinalizedJobsToggle,
        onSetSchedulerToHorizontal,
        onSetSchedulerToVertical,
        onShowWeekendsToggle,
    } = useJobTimelineViewEventHandlers()

    return (
        <Popover.View componentId="main">
            <Popover.Body>
                <div className={styles.tabStacks}>
                    <div className={styles.section}>
                        <div className={styles.sectionTitle}>Orientation</div>
                        <TabStack variant="contained" size="lg" isFullWidth={true}>
                            <TabItem
                                icon={faIcon({ name: "objects-align-left", style: "regular" })}
                                iconActive={faIcon({ name: "objects-align-left", style: "solid" })}
                                orientation="vertical"
                                isSelected={timelineViewOrientation === "horizontal"}
                                onClick={onSetSchedulerToHorizontal}
                                noDebounce={true}
                            >
                                Horizontal
                            </TabItem>
                            <TabItem
                                icon={faIcon({ name: "objects-align-top", style: "regular" })}
                                iconActive={faIcon({ name: "objects-align-top", style: "solid" })}
                                orientation="vertical"
                                isSelected={timelineViewOrientation === "vertical"}
                                onClick={onSetSchedulerToVertical}
                                noDebounce={true}
                            >
                                Vertical
                            </TabItem>
                        </TabStack>
                    </div>

                    <div className={styles.section}>
                        <div className={styles.sectionTitle}>Time frame</div>
                        <TimelineViewTimeFrameSelector />
                    </div>
                </div>

                <div className={styles.listItems}>
                    {timelineViewOrientation === "horizontal" && (
                        <ToggleListItem
                            label="Compact view"
                            checked={jobCardStyle === "compact"}
                            onCheckedChange={(checked) =>
                                checked ? setJobCardStyleToCompact() : setJobCardStyleToRegular()
                            }
                        />
                    )}

                    <ToggleListItem
                        label="Show finalized jobs"
                        checked={shouldShowFinalizedJobs}
                        onCheckedChange={onFinalizedJobsToggle}
                    />
                    <ToggleListItem
                        label="Show cancelled jobs"
                        checked={shouldShowCancelledJobs}
                        onCheckedChange={onCancelledJobsToggle}
                    />
                    <ToggleListItem
                        label="Show weekends"
                        checked={shouldShowWeekends}
                        onCheckedChange={onShowWeekendsToggle}
                    />
                </div>
            </Popover.Body>
        </Popover.View>
    )
}
